export default "__VITE_ASSET__cup3ePfK__"